import {
  getMessaging,
  type MessagePayload,
  type NextFn,
  type Observer,
  onMessage,
  type Unsubscribe,
} from 'firebase/messaging';
import { firebaseApp } from '../../firebase.config';

export type { MessagePayload } from 'firebase/messaging';

export const onForegroundMessage = (
  nextOrObserver: NextFn<MessagePayload> | Observer<MessagePayload>
): Unsubscribe => {
  return onMessage(getMessaging(firebaseApp), nextOrObserver);
};
